module.exports = __webpack_public_path__ + "static/media/buy_report_service_4.bc5fc7c0.png";